import { ConfigProvider } from 'antd';
import { enableMapSet } from 'immer';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { guardPageTranslation } from 'src/lib/guardPageTranslation';
import { antdConfig } from 'src/lib/theme';
import { CurrentAPIAnalyserRouter } from 'src/router/current-api-analyser.router';
import 'mapbox-gl/dist/mapbox-gl.css';
import '../css/leaderboard.scss';

// makes the use of Map and Set in immer.js possible
enableMapSet();
guardPageTranslation();

const container = document.getElementById('root');
if (container == null) throw new Error('Could not find root element');

const root = createRoot(container);
root.render(
  <StrictMode>
    <ConfigProvider {...antdConfig}>
      <CurrentAPIAnalyserRouter />
    </ConfigProvider>
  </StrictMode>,
);
